import { useHomeNewMetadata } from "../../queries/useHomeNewMetaData"
import LinkButtonRed from "../buttons/linkButtonRed/linkButtonRed"
import SubmenuList from "./menuList/subMenu/SubmenuList"
import React, { memo, useEffect, useState } from "react"
import * as style from "./header.module.css"
import MenuClose from "../svg/menuClose"
import DownIcon from "../svg/DownIcon"
import { Link } from "gatsby"
import OptimizedImage from "../ImageShow/OptimizedImage"

const WebHeader = ({
  headerClass,
  menuItemsList,
  resMenuItemsList,
  showButton,
}) => {
  const homeData = useHomeNewMetadata()

  const whiteLogo =
    homeData?.wpPage?.homePageNewFields?.siteWhiteLogo?.mediaItemUrl
  const blackLogo =
    homeData?.wpPage?.homePageNewFields?.siteBlackLogo?.mediaItemUrl

  const [SubItem, setSubItem] = useState([])
  const [isCheck, setIsCheck] = useState(true)
  const [isLogo, setIsLogo] = useState(false)
  const [isActiveMenu, setIsActiveMenu] = useState("false")
  const [headerClassName, setHeaderClassName] = useState("")
  
  useEffect(() => {
    handleScroll(headerClassName)
  }, [headerClassName])

  const handleToggleMenu = () => {
    setIsActiveMenu(!isActiveMenu)
  }

  useEffect(() => {
    window.onscroll = () => handleScroll(headerClassName)
    const ul = document.querySelector(".site_navigation_listing")
    ul?.addEventListener("click", function (e) {
      const mItem = e.target
      if (!mItem.classList.contains("li")) return
      const wasActive = mItem.classList.contains("active")
      document.querySelector(".active")?.classList?.remove("active")
      mItem.classList.toggle("active", !wasActive)
    })
  }, [headerClassName])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedClass = localStorage.getItem("headerClass") || ""
      setHeaderClassName(storedClass)

      window.addEventListener("scroll", handleScroll)
      return () => window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const handleScroll = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY >= 30 && headerClassName !== "sticky_header") {
        setHeaderClassName("sticky_header")
        localStorage.setItem("headerClass", "sticky_header")
      } else if (window.scrollY < 1 && headerClassName === "sticky_header") {
        setHeaderClassName("")
        localStorage.removeItem("headerClass")
      }
    }
  }

  // submenu filter
  const handleItemClick = (itemName, type) => {
    setIsCheck(!["About", "Resources", "Capabilities"].includes(itemName))
    setIsLogo(["About", "Resources", "Capabilities", "What we do", "Who we serve"].includes(itemName))
    let subItemList
    if (type === "menu") {
      subItemList = menuItemsList.filter(item => item.menuItemText === itemName)
    } else {
      subItemList = resMenuItemsList.filter(
        item => item.resMenuItemText === itemName
      )
    }
    setSubItem([])
    setSubItem(subItemList)
    if (subItemList[0]?.menuHasLink === "yes") {
      document.body.classList.remove("body-class-open")
    } else {
      document.body.classList.add("body-class-open")
    }
  }

  function removeClass() {
    setIsCheck(true)
    setIsLogo(false)
    document.body.classList.remove("body-class-open")
    setSubItem([])
  }

  return (
    <header className={`${isCheck && headerClassName} ${headerClass}`}>
      <div className="container">
        <div className={style.header_wrapper}>
          <i className={style.menu_Close} onClick={() => removeClass()}>
            <MenuClose />{" "}
          </i>
          <Link
            onClick={() => removeClass()}
            to="/"
            className={`header_new_logo ${style.header_logo}`}
          >
            {!isLogo ?
              !headerClass?.includes("red-header") ?
                <OptimizedImage
                  imageData={whiteLogo ?? "/images/placeholder-image.jpg"}
                  alt="Agile Infoways"
                  pictureclass="white-logo"
                  loading="eager"
                /> :
                <OptimizedImage
                  imageData={blackLogo ?? "/images/placeholder-image.jpg"}
                  alt="Agile Infoways"
                  pictureclass="black-logo"
                />
              :
              <OptimizedImage
                imageData={blackLogo ?? "/images/placeholder-image.jpg"}
                alt="Agile Infoways"
                pictureclass="black-logo"
              />}
          </Link>
          <div className={style.nav_right}>
            <nav
              className={`${style.site_navigation} ${isActiveMenu ? "" : "active-nav"
                }`}
            >
              <ul
                className={`${style.site_navigation_listing} site_navigation_listing`}
              >
                {menuItemsList?.map((val, i) => {
                  return (
                    <li key={`${val?.menuItemLink?.uti}_${i}`}>
                      <Link
                        key={val.menuItemText}
                        to={
                          val.menuHasLink === "yes"
                            ? val.menuItemLink?.uri
                            : "#"
                        }
                        // className="custom_nav"
                        className={`custom_nav ${SubItem[0]?.menuItemText === val.menuItemText
                          ? style.activeMenu
                          : ""
                          }`}
                        onClick={() =>
                          handleItemClick(val.menuItemText, "menu")
                        }
                        onDoubleClick={() => removeClass()}
                      >
                        {val.menuItemText}
                        <i className={style.down_ar}>
                          <DownIcon />
                        </i>
                      </Link>
                    </li>
                  )
                })}
                {resMenuItemsList?.map((val, i) => {
                  return (
                    <li key={`${val.resMenuItemText}_${i}`}>
                      <Link
                        key={val.resMenuItemText}
                        to="#"
                        // className="custom_nav"
                        className={`custom_nav ${SubItem[0]?.resMenuItemText === val.resMenuItemText
                          ? style.activeMenu
                          : ""
                          }`}
                        onClick={() =>
                          handleItemClick(val.resMenuItemText, "res")
                        }
                        onDoubleClick={() => removeClass()}
                      >
                        {val.resMenuItemText}
                        <i className={style.down_ar}>
                          <DownIcon />
                        </i>
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </nav>
            <div>
              <div
                className={`custom_sub_menu ${style.sub_menu} ${style.what_we_do_menu}`}
              >
                <div className={style.sub_menu_wrapper}>
                  <div className={style.sub_menu_inner}>
                    <div
                      className={`custom_sub_menu ${style.sub_menu} ${style.who_we_serve_menu}`}
                    >
                      <div className={style.sub_menu_wrapper}>
                        <div className={style.sub_menu_inner}>
                          <div className={style.sub_menu_col_left}></div>
                          <div className={`${style.sub_menu_col_right}`}>
                            <SubmenuList SubItem={SubItem} Dynamic={true} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showButton && (
              <div
                className={`toggle_menu ${isActiveMenu ? "" : "active"}`}
                onClick={handleToggleMenu}
                role="button"
                tabIndex="-24"
              >
                <div className="bar1"></div>
                <div className="bar2"></div>
                <div className="bar3"></div>
              </div>
            )}

            {showButton && (
              <LinkButtonRed
                btnText="Get Started"
                linkTo="/contact-us"
                CustomBtnClass="header-btn"
                click={() => removeClass()}
              />
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default memo(WebHeader)
